export function useChainOfThoughtEnabled(): boolean {
  return true;
}
